export default __webpack_public_path__ + "static/logo-color-8a90082a87e3aa4006422b268f1b363c.png";